// https://caniuse.com/?search=Notification
export const isNotificationApiSupported = () => 'Notification' in self;
